function createMappingBadge(suggestion, questionId, documentTypeId, onDelete, onSave, defaultValue = '', fallbackField = '', fallbackDefaultValue = '', required = false) {
    const $editor = $(
        `<div class="mapping-badge form-inline well well-sm" data-id="${suggestion.id}" style="margin-bottom: 15px;">
    <div class="container-fluid">
        <div class="row">
            <div class="col-xs-8">
                <!-- Feldname und Default-Wert -->
                <div class="form-group" style="margin-bottom: 10px;">
                    <span class="label label-info" style="display: inline-block; margin-right: 10px; vertical-align: middle; line-height: 2;">${suggestion.fieldName}</span>
                    <input class="form-control input-sm" type="text" name="defaultValue"
                           placeholder="Default-Wert..." value="${defaultValue}" 
                           style="display: inline-block; width: auto; vertical-align: middle;"/>
                </div>           
                <div class="form-group" style="margin-bottom: 10px;">
                    <span class="label" style="display: inline-block; margin-right: 10px; vertical-align: middle; line-height: 2;">Verpflichtend: </span>
                    <input class="form-control input-sm" type="checkbox" name="required"
                            ${required ? 'checked' : ''} 
                           style="display: inline-block; width: auto; vertical-align: middle;"/>
                </div>
                
                <!-- Fallback-Feld und dessen Default-Wert -->
                <div class="form-group">
                    <input class="form-control input-sm" type="text" name="fallbackField"
                           id="fallbackField${suggestion.id}${questionId}"
                           placeholder="Fallback-Feld..." value="${fallbackField}"
                           style="display: inline-block; width: auto; margin-right: 5px;"/>
                    
                    <input class="form-control input-sm" type="text" name="fallbackDefaultValue"
                           placeholder="Fallback Default-Wert" value="${fallbackDefaultValue}"
                           style="display: inline-block; width: auto;"/>
                </div>
            </div>
            
            <!-- Buttons zum Speichern und Löschen -->
            <div class="col-xs-4 text-right">
                <div class="form-group" style="margin-top: 10px;">
                    <button type="button" class="btn btn-danger btn-sm" id="removeMapping" title="Mapping entfernen">
                        <i class="glyphicon glyphicon-trash"></i>
                    </button>
                    <button type="button" class="btn btn-success btn-sm" id="saveMapping" title="Mapping speichern">
                        <i class="glyphicon glyphicon-ok"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>`
    );

    const valueMappingsHtml = `
<div class="form-group value-mappings-group" style="margin-top: 10px;">
    <label>Value-Mappings</label>
    <div class="value-mappings-list"></div>
    <button type="button" class="btn btn-xs btn-primary add-value-mapping" style="margin-top: 5px;">
        <i class="glyphicon glyphicon-plus"></i> Hinzufügen
    </button>
</div>`;

    $editor.find(".col-xs-8").append(valueMappingsHtml);

    $editor.find(".add-value-mapping").on("click", () => {
        const row = createValueMappingRow();
        $editor.find(".value-mappings-list").append(row);
    });
    $editor.find("#removeMapping").on("click", onDelete);
    $editor.find("#saveMapping").on("click", onSave);

    return $editor;
}

function createValueMappingRow(key = "", value = "") {
    const row = $(`
        <div class="value-mapping-row form-inline" style="margin-bottom: 5px;">
            <input type="text" class="form-control input-sm mapping-key" placeholder="z.B. durchgeführt" style="width: 45%;" value="${key}" />
            <span style="margin: 0 5px;">=</span>
            <input type="text" class="form-control input-sm mapping-value" placeholder="z.B. ABSD" style="width: 45%;" value="${value}" />
            <button type="button" class="btn btn-danger btn-xs remove-mapping" title="Entfernen"><i class="glyphicon glyphicon-minus"></i></button>
        </div>
    `);

    row.find(".remove-mapping").on("click", () => row.remove());
    return row;
}

function extractValueMappings($badge) {
    const mappings = {};
    $badge.find(".value-mapping-row").each(function () {
        const key = $(this).find(".mapping-key").val().trim();
        const value = $(this).find(".mapping-value").val().trim();
        if (key && value) {
            mappings[key] = value;
        }
    });
    return mappings;
}

async function initFieldMappingTypeahead(inputSelector, genericQuestionnaireTypeId, questionId) {
    const searchInput = $(`#${inputSelector}${questionId}`);
    const previewContainerId = searchInput.data("target");
    const previewContainer = $("#" + previewContainerId);
    const fields = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace("name"),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            url: `/${appLocation}admin/mapping/typeahead/${genericQuestionnaireTypeId}?query=%QUERY`,
            wildcard: '%QUERY',
            filter: (response) => {
                return (response || []).map(({fieldName, type}) => {
                    return {
                        question: questionId,
                        id: fieldName,
                        fieldName: fieldName,
                        type: type,
                        html: `<strong>${fieldName}</strong> <small>(${type})</small>`
                    };
                });
            }
        }
    });

    fields.initialize(true);

    searchInput.typeahead({hint: true, highlight: true, minLength: 2}, {
        name: "fieldMapping",
        display: "fieldName",
        source: fields.ttAdapter(),
        templates: {
            suggestion: (data) => `<div>${data.html}</div>`
        }
    }).on("typeahead:selected", (ev, suggestion) => {
        const existing = previewContainer.find(`[data-id='${suggestion.id}']`);
        if (existing.length > 0) return;

        if (ev.target.id.includes("fallbackField")) {
            $(ev).val(suggestion.fieldName);
        } else {
            const editor = createMappingBadge(
                suggestion,
                questionId,
                genericQuestionnaireTypeId,
                async () => {
                    try {
                        await del(`/${appLocation}admin/mapping/${documentTypeId}/${questionId}`);
                        editor.remove();
                    } catch (e) {
                        console.error(e);
                    }
                },
                () => patchMapping($(editor), suggestion, genericQuestionnaireTypeId, questionId)
            );

            previewContainer.append(editor);
            initFieldMappingTypeahead(`fallbackField${suggestion.id}`, documentTypeId, questionId)
            searchInput.typeahead("val", "").keyup();
        }
    });
}


async function patchMapping(selector, suggestion, documentTypeId, questionId) {
    const badge = $(selector).closest(".mapping-badge");
    const defaultValue = badge.find('input[name="defaultValue"]').val();
    const fallbackField = badge.find('input[name="fallbackField"]').val();
    const fallbackDefaultValue = badge.find('input[name="fallbackDefaultValue"]').val();
    const required = badge.find('input[name="required"]').prop('checked');
    const valueMappings = extractValueMappings(badge);

    delete suggestion.html;
    try {
        await patch(`/${appLocation}admin/mapping/${documentTypeId}`, {
            ...suggestion,
            question: questionId,
            defaultValue,
            fallbackField,
            fallbackDefaultValue,
            required,
            valueMappings
        });
    } catch (e) {
        console.error(e);
    }
}

function populateExistingMappings(questionId, documentTypeId, previewContainer, allMappings) {
    const $previewContainer = $(previewContainer);
    const relevantMappings = (allMappings || []).filter(m => (m.question === questionId));

    relevantMappings.forEach(mapping => {
        const {fieldName, type, defaultValue, fallbackField, fallbackDefaultValue, required} = mapping;

        const editor = createMappingBadge(
            {id: fieldName, fieldName, type},
            questionId,
            documentTypeId,
            async () => {
                try {
                    await del(`/${appLocation}admin/mapping/${documentTypeId}/${questionId}`);
                    editor.remove();
                } catch (e) {
                    console.error(e);
                }
            },
            () => patchMapping(editor, {id: fieldName, fieldName, type}, documentTypeId, questionId),
            defaultValue,
            fallbackField,
            fallbackDefaultValue,
            required
        );

        if (mapping.valueMappings) {
            Object.entries(mapping.valueMappings).forEach(([key, val]) => {
                const row = createValueMappingRow(key, val);
                editor.find(".value-mappings-list").append(row);
            });
        }

        $previewContainer.append(editor);

        if (fallbackField) {
            initFieldMappingTypeahead(
                `fallbackField${fieldName}${questionId}`,
                documentTypeId,
                questionId
            );
        }
    });
}
